// UpdatePassageTimeStampRequest.
//
// Class representing a request to update a passage time stamp.
// The caller supplies a PassageWaveformId; the backend resolves the parent Passage record.
export class UpdatePassageTimeStampRequest {
  // PassageWaveformId — identifies the waveform whose parent Passage timestamp will be updated.
  public passageWaveformId: number;

  // Update passage time stamp.
  public passageTimeStamp: Date;

  // Constructor.
  public constructor(passageWaveformId: number, passageTimeStamp: Date) {
    this.passageWaveformId = passageWaveformId;
    this.passageTimeStamp = passageTimeStamp;
  }
}
